const items = [
  {
    menu: {
      header: 'Our Story',
      link: '/about/',
      activeName: 'about',
    }
  },
  {
    menu: {
      header: 'Team',
      link: '/about/team/',
      activeName: 'team',
    }
  },
  {
    menu: {
      header: 'Careers',
      link: '/careers/',
      activeName: 'careers',
    }
  },
  {
    menu: {
      header: 'Press',
      link: '/about/press/',
      activeName: 'press',
    }
  },
  {
    menu: {
      header: 'FAQ',
      link: '/about/faq/',
      activeName: 'legal',
    }
  },
  {
    menu: {
      header: 'Partnerships',
      link: 'http://visit.policygenius.com/affiliate-partners/',
      activeName: 'partnerships',
    }
  },
];

export default items;



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/aboutItems.js